import React, { useEffect, useState } from 'react'
import CustomSelect from '../../Components/CustomSelect'
import { axiosInstance } from '../../Helpers/axiosInstance'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Users() {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [position, setPosition] = useState("")
    const [name, setName] = useState("")
    const [surname, setSurname] = useState("")
    const [fathersName, setFathersName] = useState("")
    const [rang, setRang] = useState("")
    const [role, setRole] = useState("")
    const [type, setType] = useState("")
    const [user_corpus, setUserCorpus] = useState("")
    const [user_mil_unit, setUserMilUnit] = useState("")
    const [user_battalion, setUserBattalion] = useState("")
    const [user_company, setUserCompany] = useState("")
    const [corpuses, setCorpuses] = useState([])
    const [milUnits, setMilUnits] = useState([])
    const [battalions, setBattalions] = useState([])
    const [companies, setCompanies] = useState([])
    const [clear, setClear] = useState(false)

    const rangList = ["կուրսանտ", "շ-ն", "եֆր․", "կրտ․ ս-տ", "ս-տ", "ավ․ ս-տ", "ավագ", "ենթ․","ավ․ ենթ․", "լ-տ", "ավ․ լ-տ", "կ-ն․", "մ-ր", "փ/գ-տ", "գ-տ", "գեն․ մ-ր", "գեն․ լ-տ", "գեն գ-տ"]

    useEffect(() => {
        (async() => {
            const corpuses = await axiosInstance.get('admin/corpuses')
            if(corpuses.status){
                setCorpuses(corpuses.data.data)
            }
        })()
    }, [])

    useEffect(() => {
        (async() => {
            const milunits = await axiosInstance.get('admin/milunits')
            if(milunits.status){
                setMilUnits(milunits.data.data)
            }
        })()
    }, [])

    useEffect(() => {
        (async() => {
            const batalions = await axiosInstance.get('admin/battalions')
            if(batalions.status){
                setBattalions(batalions.data.data)
            }
        })()
    }, [])

    useEffect(() => {
        (async() => {
            const companies = await axiosInstance.get(`admin/companies`)
            if(companies.status){
                setCompanies(companies.data.data)
            }
        })()
    }, [])

    const submitHandler = async () => {
        if(username.length < 3){
            return toast.error("Օգտանունը պետք է պարունակի մինիմում 3 սիմվոլ")
        }
    
        if(password.length < 8){
            return toast.error("Գաղտնաբառը պետք է պարունակի մինիմում 8 սիմվոլ")
        }
        if(!username || !password || !type || !role){
            toast.error("Լրացրե՛ք բոլոր պարտադիր դաշտերը (նշված են \"*\" նշանով)")
            return
        }
        if(type === "Corpus" && !user_corpus){
            toast.error("Լրացրե՛ք բոլոր պարտադիր դաշտերը (նշված են \"*\" նշանով)")
            return
        }else if(type === "Milunit" && (!user_corpus || !user_mil_unit)){
            toast.error("Լրացրե՛ք բոլոր պարտադիր դաշտերը (նշված են \"*\" նշանով)")
            return
        }else if(type === "Battalion" && (!user_corpus || !user_mil_unit || !user_battalion)){
            toast.error("Լրացրե՛ք բոլոր պարտադիր դաշտերը (նշված են \"*\" նշանով)")
            return
        }else if(type === "Company" && (!user_corpus || !user_mil_unit || !user_battalion || !user_company)){
            toast.error("Լրացրե՛ք բոլոր պարտադիր դաշտերը (նշված են \"*\" նշանով)")
            return
        }

        const obj = {username, password, position, name, surname, fathersName, rang, role, user_type: type}
        if(user_corpus){
            obj.user_corpus = user_corpus
        }
        if(user_mil_unit){
            obj.user_mil_unit = user_mil_unit
        }
        if(user_battalion){
            obj.user_battalion = user_battalion
        }
        if(user_company){
            obj.user_company = user_company
        }

        const res = await axiosInstance.post("/auth/singup-admin", obj)
        if(res.data.status){
            toast.success("Օգտատիրոջ տվյալները հաջողությամբ պահպանվեցին")
        }
    }

  return (
    <div className='mx-5 text-center'>
        <h2 className='my-5'>Ավելացնել օգտատեր</h2>
        <div className='grid grid-cols-2 gap-4'>
            <div className='relative'>
                <label htmlFor='username' className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]">Մուտքանուն*</label>
                <input id="username" type="text" className='w-full border border-gray-500 rounded-md p-2' onChange={e => setUsername(e.target.value)} />
            </div>
            <div className='relative'>
                <label htmlFor='password' className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]">Գաղտնաբառ*</label>
                <input id="password" type="password" className='w-full border border-gray-500 rounded-md p-2' onChange={e => setPassword(e.target.value)} />
            </div>
            <div className='relative'>
                <label htmlFor='name' className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]">Անուն</label>
                <input id="name" type="text" className='w-full border border-gray-500 rounded-md p-2' onChange={e => setName(e.target.value)} />
            </div>
            <div className='relative'>
                <label htmlFor='surname' className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]">Ազգանուն</label>
                <input id="surname" type="text" className='w-full border border-gray-500 rounded-md p-2' onChange={e => setSurname(e.target.value)} />
            </div>
            <div className='relative'>
                <label htmlFor='fathersName' className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]">Հայրանուն</label>
                <input id="fathersName" type="text" className='w-full border border-gray-500 rounded-md p-2' onChange={e => setFathersName(e.target.value)} />
            </div>
        </div>
        <div className='grid grid-cols-2 gap-4 mt-4'>
            <div className='relative'>
                <label htmlFor='position' className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]">Պաշտոն</label>
                <input id="position" type="text" className='w-full border border-gray-500 rounded-md p-2' onChange={e => setPosition(e.target.value)} />
            </div>
            <div className='relative'>
                <CustomSelect 
                    defaultValueForInput={rang}
                    options={rangList?.map((el,i) => <option key={i} value={el}>{el}</option>)}
                    callback={setRang}
                    label="Զինկոչում"
                />
            </div>
            <div className='relative'>
                <label htmlFor='type' className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]">Տեսանելության սահմաններ*</label>
                <select id="type" onChange={e => setType(e.target.value)} style={{width: "100%"}}>
                    <option value=""></option>
                    <option value="Headquarter">Նախարարություն</option>
                    <option value="Corpus">Կորպուս</option>
                    <option value="Milunit">Զորամաս</option>
                    <option value="Battalion">Գումարտակ</option>
                    <option value="Company">Վաշտ</option>
                </select>
            </div>
            <div className='relative'>
                <label htmlFor='role' className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px]" onChange={e => setRole(e.target.value)}>Օգտատիրոջ տեսակ*</label>
                <select id="role" style={{width: "100%"}} onChange={e => setRole(e.target.value)}>
                    <option value=""></option>
                    <option value="User">Հասարակ օգտատեր</option>
                    <option value="Admin">Ադմինիստրատոր</option>
                </select>
            </div>
            {(type === "Corpus" || type === "Milunit" || type === "Battalion" || type === "Company") && <div>
                <CustomSelect 
                    defaultValueForInput={user_corpus ? corpuses.find(el => el._id === user_corpus)?.corpus_number + " " + corpuses.find(el => el._id === user_corpus)?.corpus_name : ''}
                    options={corpuses.map((el,i) => <option key={i} value={el._id}>{el.corpus_number + " " + el.corpus_name}</option>)}
                    callback={setUserCorpus}
                    label="Ընտրել կորպուսը*"
                    clear={clear}
                />
            </div>}
            {(type === "Milunit" || type === "Battalion" || type === "Company") && <div>
                <CustomSelect 
                    defaultValueForInput={user_mil_unit ? user_mil_unit.unit_number : ''}
                    options={milUnits?.map((el,i) => <option key={i} value={el._id}>{el.unit_number}</option>)}
                    callback={setUserMilUnit}
                    label="Ընտրել զորամասը*"
                    clear={clear}
                />
            </div>}
            {(type === "Battalion" || type === "Company") && <div >
                <CustomSelect 
                    defaultValueForInput={user_battalion ? user_battalion.battalion_number : ''}
                    options= {battalions?.map((el,i) => <option key={i} value={el._id}>{el.battalion_number}</option>)}
                    callback={setUserBattalion}
                    label="Ընտրել գումարտակը*"
                    clear={clear}
                />
            </div>}
            {type === "Company" && <div >
                <CustomSelect 
                    defaultValueForInput={user_company ? user_company.company_number : ''}
                    options= {companies?.map((el,i) => <option key={i} value={el._id}>{el.company_number}</option>)}
                    callback={setUserCompany}
                    label="Ընտրել վաշտը*"
                    clear={clear}
                />
            </div>}
        </div>
        <div className='w-1/5 mx-auto my-5'>
            <button className='confirm-btn' onClick={submitHandler}>Հաստատել</button>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
